module.exports = __webpack_public_path__ + "img/logo-both.08e962b9.jpg";